// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cb7p","placeholdersHeader":"styles_placeholdersHeader__3rYD0","editorStyle":"styles_editorStyle__3VEEF","placeholdersBox":"styles_placeholdersBox__lIzGq"};